export const condition = {
  URL_DATA: "URL_DATA",
  PDF_DATA: "PDF_DATA",
  CACHE_TEXT_QNA: "CACHE_TEXT_QNA",
  CACHE_MUTUAL_FUND: "CACHE_MUTUAL_FUND",
  CACHE_GREETING: "CACHE_GREETING",
  CACHE_BING_QNA: "CACHE_BING_QNA",
  UPLOAD_URL_MODAL_OPEN: "UPLOAD_URL_MODAL_OPEN",
  ALERT_MODAL_OPEN: "ALERT_MODAL_OPEN",
  ALERT_MESSAGE: "ALERT_MESSAGE",
  SETACTIVETAB: "SETACTIVETAB",
  SETCTALINKS: "SETCTALINKS",
  SETPROMPTSLIST: "SETPROMPTSLIST",
  LOGS_DATA: "LOGS_DATA",
  API_LOGS_DATA: "API_LOGS_DATA",
  ERROR_LOGS_DATA: "ERROR_LOGS_DATA",
};
